import React from "react";
import "./FreeConsultModal.css";

import Modal from "react-bootstrap/Modal";
import { Link, useLocation } from "react-router-dom";

function ModalFunc(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="sale-modal"
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="saleModalHeader" closeButton></Modal.Header>
      <Modal.Body>
        <div className="saleModal-content">
          <h4>Hire A Virtual Assistant</h4>
          <p>
            Fill out the form below and we will be in touch to discuss your
            requirement
          </p>

          <form>
            <input type="text" placeholder="Full Name*" />
            <input type="text" placeholder="Business Email*" />
            <input type="text" placeholder="Phone*" />
            <select>
              <option>Virtual Assistance</option>
              <option>Ecommerce Virtual Assistance</option>
              <option>Creative Design Virtual Assistance</option>
              <option>Web Development Virtual Assistance</option>
            </select>
            <input type="text" placeholder="Company Name*" />

            <button>Submit</button>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );
}

function FreeConsultModal({ startTrial, learmMore, hireAVA }) {
  const [modalShow, setModalShow] = React.useState(false);

  const location = useLocation();
  const locationURL = location.pathname;

  return (
    <>
      <Link to={"#"} className="orange-btn" onClick={() => setModalShow(true)}>
        {locationURL === "/pricing"
          ? startTrial
          : locationURL === "/about-us"
          ? learmMore
          : locationURL === "/contact-us"
          ? hireAVA
          : "Free Consultation"}
      </Link>

      <ModalFunc show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}

export default FreeConsultModal;
